import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./Header.css";
import logo from "./Images/logoSamol.png";

const ONE_PAGE_LINKS = [
  { anchor: "#accueil", label: "Accueil" },
  { anchor: "#a-propos", label: "À propos" },
  { anchor: "#solutions", label: "Nos solutions" },
  { anchor: "#solutions-ecoles", label: "Solutions écoles" },
  { anchor: "#solutions-pme", label: "Solutions PME" },
  { anchor: "#nos-realisations", label: "Nos réalisations" },
  { anchor: "#contact", label: "Contact / Audit" },
];

const MULTI_PAGE_LINKS = [
  { path: "/", label: "Accueil" },
  { path: "/about", label: "À propos" },
  { path: "/services", label: "Nos solutions" },
  { path: "/solutions-ecoles", label: "Solutions écoles" },
  { path: "/solutions-pme", label: "Solutions PME" },
  { path: "/nos-realisations", label: "Nos réalisations" },
  { path: "/contact", label: "Contact / Audit" },
];

function Header({ onePage = false }) {
  const [isOpen, setIsOpen] = useState(false);
  const [activeAnchor, setActiveAnchor] = useState("#accueil");

  const navLinks = onePage ? ONE_PAGE_LINKS : MULTI_PAGE_LINKS;

  useEffect(() => {
    if (!onePage) {
      return undefined;
    }

    const anchors = ONE_PAGE_LINKS.filter((link) => link.anchor).map((link) => link.anchor);
    const sectionOffset = 140;

    const updateActiveSection = () => {
      let current = anchors[0];

      anchors.forEach((anchor) => {
        const section = document.querySelector(anchor);

        if (section && section.getBoundingClientRect().top - sectionOffset <= 0) {
          current = anchor;
        }
      });

      setActiveAnchor(current);
    };

    if (window.location.hash && anchors.includes(window.location.hash)) {
      setActiveAnchor(window.location.hash);
    }

    updateActiveSection();
    window.addEventListener("scroll", updateActiveSection, { passive: true });
    window.addEventListener("resize", updateActiveSection);

    return () => {
      window.removeEventListener("scroll", updateActiveSection);
      window.removeEventListener("resize", updateActiveSection);
    };
  }, [onePage]);

  return (
    <header className="headerhead">
      <nav className="header-nav" aria-label="Navigation principale">
        <div className="nav-logo">
          {onePage ? (
            <a href="#accueil" className="logo-link" onClick={() => setIsOpen(false)}>
              <img src={logo} alt="Samol Technologies" className="logo" />
            </a>
          ) : (
            <Link to="/" className="logo-link" onClick={() => setIsOpen(false)}>
              <img src={logo} alt="Samol Technologies" className="logo" />
            </Link>
          )}
        </div>

        <button
          className={`menu-toggle ${isOpen ? "open" : ""}`}
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Ouvrir le menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`nav-links ${isOpen ? "show" : ""}`}>
          {navLinks.map((link) => (
            <li key={link.path || link.anchor}>
              {link.anchor ? (
                <a
                  href={link.anchor}
                  onClick={() => {
                    setActiveAnchor(link.anchor);
                    setIsOpen(false);
                  }}
                  className={onePage && activeAnchor === link.anchor ? "active" : ""}
                >
                  {link.label}
                </a>
              ) : (
                <NavLink
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  {link.label}
                </NavLink>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
}

export default Header;
